import "./index.scss";
import { $, $all, forEach, on, addClass, removeClass } from "@olmokit/dom";

import { render } from "@olmokit/utils/render";
import { post } from "@olmokit/core/fragments/ajax";
import { globalData } from "@olmokit/core/data";

import ScrollToPlugin from "gsap/ScrollToPlugin";
import gsap from "gsap";
gsap.registerPlugin(ScrollToPlugin);

const $product = $("#card-product");
const $pagination = $("#pagiantion-filters");

const renderCardProduct = render($product.innerHTML);
const renderFilterPagination = render($pagination.innerHTML);

/**
 * Component: FiltersPagination
 */
export function FiltersPagination(queryBrands) {
  console.log("FiltersPagination mounted.");

  const $links = $all('a.page-link');
  const $items = $all('.page-item');
  forEach($links, (link) => {
    on(link, 'click', () => {
      
      const $element = $('.border-top');
      
      gsap.to(window, { duration: 0.2, scrollTo: $element });      
      const href = link.getAttribute('href');

      forEach($items, (item) => {
        removeClass(item, 'active');
      });

      addClass(link.parentNode, 'active');

      filter(href, queryBrands);
      // console.log(href);
    });
  });

}

function filter(id, queryBrands) {

  const loader = $('.loader');
  // const numProd = $('#numProd');

  loader.style.display = 'flex';  

  post('filters', {
    data: {
      id: '',
      idpage: id.replace('#', ''),
      macrocategory: globalData.macroidcat,
      category: globalData.idcat,
      brands: queryBrands
    },
  }).then(({ data }) => {

    console.log(data);

    const $products = $("#card-products");
    const $paginationfilter = $("#pagination");
    const $numProd = $("#productFound");
    const $numTotal = $("#productTotal");

    $products.innerHTML = renderCardProduct({
      results: data.elements
    });
    // new LazyLoad();

    const array = [];
    for(let i = 0; i < data.pagenumber; i++){
      array.push(i+1);
    }

    $paginationfilter.innerHTML = renderFilterPagination({
      results: data.elements,
      pagenumber: array,
      pagecurrent: data.pagecurrent,
      fulltotal: data.fulltotal,
    });
    
    if(data.fulltotal > 100){
      FiltersPagination(queryBrands);
    }    

    $numProd.innerHTML = data.count;
    $numTotal.innerHTML = data.fulltotal;

    loader.style.display = 'none';

  });      
}